export default __webpack_public_path__ + "static/coronini_img2-7e49afe971c9a38fd17e37b712e2b2e7.png";